

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'


import { VueReCaptcha } from 'vue-recaptcha-v3'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.config.productionTip = false



Vue.use(VueAxios, axios
);



Vue.use(VueReCaptcha, {
  siteKey: '6LdOHeEqAAAAAL3_AT0hKoGydYWxfOqO0F9DKG8F',
  loaderOptions: {
    useRecaptchaNet: true
  }
});




new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')


